module.exports = __webpack_public_path__ + "img/566.dc9b0d81.jpg";